var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-o-auth-2',[_c('p',{staticStyle:{"color":"white","margin-top":"21px"}},[_vm._v("\n        Authentication...\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }